/**
 * Public legal identification and customer-facing contact details. These are
 * fixed corporate facts, not per-environment configuration, so they live here
 * instead of in `.env`.
 */
export const SYNGENTA_LEGAL_NAME = 'Syngenta Proteção de Cultivos Ltda';
export const SYNGENTA_CNPJ = '60.744.463/0001-90';

export const CREDIT_EMAIL_CONTACT = 'faleconosco.casa@syngenta.com';
export const CREDIT_PHONE_CONTACT = '0800 704 4304';
export const SUPPORT_URL = 'https://www.syngenta.com.br/servicos-casa';
